import { useParams } from "react-router-dom";

type RouteParams = {
  companyId?: string;
};

export const useCompanyIdFromRoute = () => {
  const { companyId } = useParams<RouteParams>();
  return companyId ?? null;
};
